module.exports = __webpack_public_path__ + "static/media/exo-latin-700italic.c40b3ba6.woff2";